import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { TestRunExecution } from '../../models/test-run.model';
import { TestRunService } from '../../services/test-run.service';

function routeParam(route: ActivatedRouteSnapshot, name: string): string {
  return route.pathFromRoot.reduce((found, step) => step.paramMap.get(name) ?? found, '');
}

export function newest(executions: TestRunExecution[]): TestRunExecution | null {
  return executions.reduce<TestRunExecution | null>((top, e) => (!top || e.nr > top.nr ? e : top), null);
}

export const ciMappingRedirectGuard: CanActivateFn = (route): UrlTree | Observable<UrlTree> => {
  const router = inject(Router);
  const projectId = routeParam(route, 'projectId');
  const runId = routeParam(route, 'runId');
  const executions = ['/projects', projectId, 'test-runs', runId, 'executions'];
  const unmatchedOf = (executionId: string): UrlTree =>
    router.createUrlTree([...executions, executionId], { queryParams: { filter: 'unmatched' } });

  const executionId = route.queryParamMap.get('executionId');
  if (executionId) return unmatchedOf(executionId);

  return inject(TestRunService)
    .listExecutions(projectId, runId)
    .pipe(
      map((list) => {
        const target = newest(list);
        return target ? unmatchedOf(target.id) : router.createUrlTree(executions);
      }),
      catchError(() => of(router.createUrlTree(executions))),
    );
};
